// ** Vertical Menu Components
import VerticalNavMenuLink from './VerticalNavMenuLink'
import VerticalNavMenuGroup from './VerticalNavMenuGroup'
import VerticalNavMenuSectionHeader from './VerticalNavMenuSectionHeader'

// ** Utils
import {resolveVerticalNavMenuItemComponent as resolveNavItemComponent} from '@layouts/utils'
import {useReducer, useState} from "react";
import {getUserData} from "../../../../../utility/Utils";
import navigationItems from "../../../../../navigation/vertical";

export function getNavigationItems(myItems) {
    let role = (getUserData() && getUserData().userData) ? getUserData().userData.role : null;
    let myNavigationItems = myItems;
    if (role !== null) {
        myNavigationItems = myNavigationItems.filter((item) => {
            let hasAcces = false;
            item.roles.map((singleRole) => {
                role.map((userRole) => {
                    if (userRole === singleRole) {
                        hasAcces = true;
                    }
                })
            })
            return hasAcces
        })

        myNavigationItems = myNavigationItems.map((item) => {
            if (item.children == null) {
                return item;
            }
            item.children = item.children.filter((child) => {
                let hasAcces = false;
                child.roles.map((singleRole) => {
                    role.map((userRole) => {
                        if (userRole === singleRole) {
                            hasAcces = true;
                        }
                    })
                })
                return hasAcces
            });
            return item;
        });
    }

    return myNavigationItems;
}

const VerticalMenuNavItems = props => {
    const [menuItems, setMenuItems] = useState(getNavigationItems(props.items));
    const Components = {
        VerticalNavMenuSectionHeader,
        VerticalNavMenuGroup,
        VerticalNavMenuLink
    }


    // ** Render Nav Menu Items
    const RenderNavItems = menuItems.map((item, index) => {
        const TagName = Components[resolveNavItemComponent(item)]

        return <TagName key={item.id || item.header} item={item} {...props} />
    })

    return RenderNavItems
}

export default VerticalMenuNavItems
